import type { TierColors, TileType } from "./types";

export const TILE_COLOR: Record<TileType, string> = {
  rakeback: "#49B356",
  cashback: "#3E7BD6",
  levelUp: "#8B5CF6",
  tierUp: "#C9964F",
  monthlyBonus: "#C24FA8",
  link: "#505866",
};

export const LOCKED_TIER: TierColors = {
  sheen: "#3F4855",
  body: "#323B47",
  base: "#2C343F",
  bar: "#6D7884",
  badgeLight: "#4A545F",
  badgeDark: "#171C22",
};
